/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum FlaggedItemObjectType {
    Document = 0,
    Interrogatory = 1
}

export function FlaggedItemObjectTypeFromJSON(json: any): FlaggedItemObjectType {
    return FlaggedItemObjectTypeFromJSONTyped(json, false);
}

export function FlaggedItemObjectTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlaggedItemObjectType {
    return json as FlaggedItemObjectType;
}

export function FlaggedItemObjectTypeToJSON(value?: FlaggedItemObjectType | null): any {
    return value as any;
}

